export const ActionTypes = {
    UPDATE_SELECTED_TAB_INDEX: "UPDATE_SELECTED_TAB_INDEX",
};

export function updateSelectedTabIndex(newIndex) {
    return {
        type: ActionTypes.UPDATE_SELECTED_TAB_INDEX,
        selectedTabIndex: newIndex,
    };
}

const exported = { ActionTypes, updateSelectedTabIndex };

export default exported;
